export const API_HOMOLOG_ENDPOINT = (process.env.API_HOMOLOG_ENDPOINT || 'http://localhost:4000').trim();
export const API_ENDPOINT = (process.env.API_ENDPOINT || 'https://varejo.ti9.com.br').trim();
